import React, { useState, useRef, useEffect, useMemo } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import qs from "qs";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Input,
  Col,
  Row,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
  threeColumnFormItemLayout,
} from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onSubmitForm,
  onChange,
  onUpdateStatus,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onWarehouseSearch,
  onBranchSearch,
  onProjectSearch,
  onEmployeeSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import simpleMathFunction from "../../utils/simpleMathFunction";
import round from "../../utils/round";
import axios from "axios";
import { sumBy, uniq } from "lodash";
import WarehouseFormModal from "../modals/WarehouseFormModal";
import { Link, useMatch, useNavigate, useParams } from "react-router-dom";
import numberFormatInt from "../../utils/numberFormatInt";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import validator from "validator";
import FormButtons from "../../commons/FormButtons";
import classNames from "classnames";
import {
  ACCESS_ADD,
  ACCESS_ADVANCE_SEARCH,
  ACCESS_OPEN,
  CANCELLED,
  OPEN,
  STATUS_CLOSED,
} from "../../utils/constants";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import AccountFormModal from "../modals/AccountFormModal";
import StockFormModal from "../modals/StockFormModal";
import computeItemDetails from "../../utils/computeItemDetails";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import EmployeeModal from "../modals/EmployeeModal";

const { Content } = Layout;
const { Panel } = Collapse;

const transaction = "project-estimates";
const url = `/api/${transaction}/`;
const title = "Project Estimates";

const initialItemValues = {
  stock: "",
  quantity: "",
  price: "",
  amount: "",
  actual_amount: "",
  supplier: "",
  notes: "",
};

const transaction_counter = {
  label: "EST #",
  key: "estimate_no",
};

const date_fields = ["date", "deadline"];

export default function ProjectEstimatesForm({}) {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [dr_numbers, setDrNumbers] = useState([]);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const [page_size, setPageSize] = useState(100);

  const [loading, setLoading] = useState(false);
  const accountFormModal = useRef(null);
  const stockFormModal = useRef(null);
  const warehouseFormModal = useRef(null);
  const employeeModal = useRef(null);

  const navigate = useNavigate();
  const [search_state, setSearchState] = useState({});

  const initialValues = {
    _id: null,
    rr_no: null,
    date: moment(),
    supplier: null,
    warehouse: auth.user?.warehouse,
    remarks: "",
    items: [
      {
        ...initialItemValues,
      },
    ],
    discounts: [],

    purchase_order: null,
    stock_release: null,
    sales_return: null,
    customer: null,

    gross_amount: 0,
    total_discount_amount: 0,
    total_amount: 0,
  };
  const [state, setState] = useState(initialValues);

  const total_estimated_material_cost = sumBy(state.items, (o) =>
    round(o.amount)
  );

  const total_actual_material_cost = sumBy(state.items, (o) =>
    round(o.actual_amount)
  );

  const total_estimated_mobilization_cost = simpleMathFunction(
    [
      state.estimated_meals,
      state.estimated_lodging,
      state.estimated_fare_cost,
      state.estimated_car_rentals_cost,
      state.estimated_miscellaneous,
      state.estimated_diesel_cost,
    ],
    "addition"
  );

  const total_actual_mobilization_cost = simpleMathFunction(
    [
      state.actual_meals,
      state.actual_lodging,
      state.actual_fare_cost,
      state.actual_car_rentals_cost,
      state.actual_miscellaneous,
      state.actual_diesel_cost,
    ],
    "addition"
  );

  const total_estimated_labor_cost = simpleMathFunction(
    [
      state.average_daily_rate,
      state.estimated_production_crew,
      state.estimated_days,
    ],
    "multiplication"
  );

  const total_actual_labor_cost = simpleMathFunction(
    [
      state.actual_average_daily_rate,
      state.actual_production_crew,
      state.actual_days,
    ],
    "multiplication"
  );

  const total_mat_lab_mob = simpleMathFunction(
    [
      total_estimated_labor_cost,
      total_estimated_mobilization_cost,
      total_estimated_material_cost,
    ],
    "addition"
  );

  const actual_total_mat_lab_mob = simpleMathFunction(
    [
      total_actual_labor_cost,
      total_actual_mobilization_cost,
      total_actual_material_cost,
    ],
    "addition"
  );

  const contingency = simpleMathFunction(
    [total_mat_lab_mob, state.contingency_rate / 100],
    "multiplication"
  );

  const actual_contingency = simpleMathFunction(
    [actual_total_mat_lab_mob, state.contingency_rate / 100],
    "multiplication"
  );

  const records_column = [
    {
      title: "EST #",
      dataIndex: "estimate_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Project",
      dataIndex: ["project", "name"],
    },
    {
      title: "Account",
      dataIndex: ["project", "account", "name"],
    },

    {
      title: "Status",
      dataIndex: ["status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span
            className={classNames("has-text-weight-bold", {
              "has-text-danger": status?.approval_status === CANCELLED,
            })}
          >
            {status?.approval_status || ""}
          </span>
        );
      },
    },
  ];

  const taxes = useMemo(() => {
    const contract_price = state?.project?.project_price || 0;
    const total_project_cost =
      total_estimated_labor_cost +
      total_estimated_mobilization_cost +
      total_estimated_material_cost +
      contingency;

    const total_actual_project_cost =
      total_actual_labor_cost +
      total_actual_mobilization_cost +
      total_actual_material_cost +
      actual_contingency;

    const srp =
      total_project_cost + total_project_cost * (state.srp_rate / 100);

    const actual_srp =
      total_actual_project_cost +
      total_actual_project_cost * (state.srp_rate / 100);

    const total_project_margin = round(
      ((contract_price - total_project_cost) / contract_price) * 100
    );
    const total_actual_project_margin = round(
      ((contract_price - total_actual_project_cost) / contract_price) * 100
    );

    if (!state?.project?.is_taxable) {
      return {
        name: "(NON VAT)",
        contract_price,
        total_project_cost,
        total_actual_project_cost,
        srp,
        actual_srp,
        net_of_vat: contract_price,
        net_income: contract_price - total_project_cost,
        actual_net_income: contract_price - total_actual_project_cost,
        total_project_margin,
        total_actual_project_margin,
        vat: 0,
      };
    } else {
      if (state?.project?.is_vat_exclusive) {
        return {
          name: "(VAT EXCLUSIVE)",
          contract_price,
          total_project_cost,
          total_actual_project_cost,
          srp,
          actual_srp,
          net_of_vat: contract_price,
          net_income: contract_price - total_project_cost,
          actual_net_income: contract_price - total_actual_project_cost,
          total_project_margin,
          total_actual_project_margin,
          vat: contract_price * 0.12,
        };
      } else {
        return {
          name: "(VAT INCLUSIVE)",
          contract_price,
          total_project_cost,
          total_actual_project_cost,
          srp,
          actual_srp,
          net_of_vat: contract_price,
          net_income: contract_price - total_project_cost,
          actual_net_income: contract_price - total_actual_project_cost,
          total_project_margin,
          total_actual_project_margin,
          vat: contract_price - contract_price / 1.12,
        };
      }
    }
  }, [state]);

  const labor_costs = [
    {
      name: "AVERAGE DAILY RATE",
      estimate_key: "average_daily_rate",
      actual_key: "actual_average_daily_rate",
    },
    {
      name: "ESTIMATED PRODUCTION CREW",
      estimate_key: "estimated_production_crew",
      actual_key: "actual_production_crew",
    },
    {
      name: "ESTIMATED DAYS",
      estimate_key: "estimated_days",
      actual_key: "actual_days",
    },
  ];

  const mobilization_costs = [
    {
      name: "MEALS",
      estimate_key: "estimated_meals",
      actual_key: "actual_meals",
    },
    {
      name: "LODGING",
      estimate_key: "estimated_lodging",
      actual_key: "actual_lodging",
    },
    {
      name: "FARE COST",
      estimate_key: "estimated_fare_cost",
      actual_key: "actual_fare_cost",
    },
    {
      name: "CAR RENTALS",
      estimate_key: "estimated_car_rentals_cost",
      actual_key: "actual_car_rentals_cost",
    },
    {
      name: "MISCELLANEOUS",
      estimate_key: "estimated_miscellaneous",
      actual_key: "actual_miscellaneous",
    },
    {
      name: "Estimated Diesel Cost",
      estimate_key: "estimated_diesel_cost",
      actual_key: "actual_diesel_cost",
    },
  ];

  const taxes_costs = [
    {
      name: (
        <div>
          CONTRACT PRICE {taxes.name}&emsp;
          {[undefined, OPEN].includes(state.status?.approval_status) ? (
            <input
              type="number"
              name="project_price"
              value={state.project?.project_price || ""}
              //style={{ width: 60 }}
              onChange={(e) => {
                const project_price = e.target.value;

                setState((prevState) => ({
                  ...prevState,
                  project: {
                    ...prevState.project,
                    project_price,
                  },
                }));
              }}
            />
          ) : (
            state.project?.project_price || ""
          )}
        </div>
      ),
      estimate_key: "contract_price",
      actual_key: "contract_price",
    },
    {
      name: "NET OF VAT",
      estimate_key: "net_of_vat",
      actual_key: "net_of_vat",
    },
    {
      name: "VAT (12%)",
      estimate_key: "vat",
      actual_key: "vat",
    },
    {
      name: (
        <div>
          SRP &emsp;
          {[undefined, OPEN].includes(state.status?.approval_status) ? (
            <input
              type="number"
              name="srp_rate"
              value={state.srp_rate}
              style={{ width: 60 }}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />
          ) : (
            state.srp_rate
          )}
        </div>
      ),
      estimate_key: "srp",
      actual_key: "actual_srp",
    },
    {
      name: "NET INCOME",
      estimate_key: "net_income",
      actual_key: "actual_net_income",
    },
  ];

  const items_column = [
    {
      title: "",
      key: "action",
      width: 30,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() => {
                  setState((prevState) => {
                    const items = [...prevState.items];

                    items.splice(index + 1, 0, {
                      ...initialItemValues,
                      category: items[index].category,
                    });

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }}
              >
                <i className="fas fa-plus"></i>
              </span>
            )}
        </span>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  step={0.01}
                  className="input-value"
                  value={record.category}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        category: value,
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                          category: items[index].category,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            ``
          )}
        </span>
      ),
    },
    {
      title: "Item",
      dataIndex: ["stock"],
      render: (stock, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={stock?.name}
              onSearch={(value) =>
                onStockSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const stock = options.stocks?.[index] || null;

                if (stock) {
                  setState((prevState) => {
                    const items = [...(prevState.items || [])];

                    items[record_index].stock = stock;
                    items[record_index].price = stock?.cost || 0;

                    items[record_index] = {
                      ...items[record_index],
                      ...computeItemDetails({
                        ...items[record_index],
                        price: stock?.cost || 0,
                      }),
                    };

                    if (items.length - 1 === record_index) {
                      items.push({
                        ...initialItemValues,
                        category: items[record_index].category,
                      });
                    }

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.stocks}
              column="display_name"
              onAddItem={() => stockFormModal.current.open(record_index)}
            />
          )
        );
      },
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                          category: items[index].category,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 100,
    },
    {
      title: "Unit Cost",
      dataIndex: "Price",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.price}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          price: value,
                        }),
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                          category: items[index].category,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            numberFormat(record.price)
          )}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: ["amount"],
      align: "right",
      width: 100,
      render: (value) => numberFormat(value),
    },
    {
      title: "Actual Amount",
      dataIndex: "actual_amount",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.actual_amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                        }),
                        actual_amount: value,
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                          category: items[index].category,
                        });
                      }

                      console.log(items[index].actual_amount);

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            numberFormat(record.actual_amount)
          )}
        </span>
      ),
    },
    {
      title: "ADDTL REQ",
      dataIndex: ["additional_quantity"],
      align: "center",
      width: 100,
    },
    {
      title: "PO QTY",
      dataIndex: ["po_quantity"],
      align: "center",
      width: 100,
    },
    {
      title: "WW QTY",
      dataIndex: ["withdrawn_quantity"],
      align: "center",
      width: 100,
    },
    {
      title: "RET QTY",
      dataIndex: ["return_quantity"],
      align: "center",
      width: 100,
    },
    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const branch = auth?.user?.branches?.[0] || null;

    if (branch?._id) {
      setSearchState((prevState) => {
        return {
          ...prevState,
          branch,
        };
      });
    }

    setOptions((prevState) => {
      return {
        ...prevState,
        branches: auth?.user?.branches || [],
      };
    });

    return () => {};
  }, [auth.user.branches]);

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    (async () => {
      if (isEmpty(params?.id) && !isEmpty(search_state.branch?._id)) {
        setTimeout(() => {
          onSearch({
            page: current_page,
            page_size,
            search_keyword,
            url,
            setRecords,
            setTotalRecords,
            setCurrentPage,
            setErrors,
            advance_search: { ...search_state },
          });
        }, 300);
      }
    })();

    return () => {};
  }, [search_state.branch]);

  useEffect(() => {
    setState((prevState) => {
      const total_amount = sumBy(state.items, (o) => o.amount);
      const gross_amount = total_amount;
      let net_amount = gross_amount;

      (state.discounts || []).forEach((discount) => {
        let discount_rate = validator.isNumeric(discount.toString())
          ? 1 - round(discount) / 100
          : 1;

        net_amount = net_amount * discount_rate;
      });

      const total_discount_amount = round(gross_amount - net_amount);

      return {
        ...prevState,
        total_amount,
        gross_amount,
        total_discount_amount,
      };
    });

    return () => {};
  }, [state.items, state.discounts]);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: {
          _id: params.id,
        },
        setState,
        setErrors,
        setRecords,
        url,
        date_fields,
      });
    }
    return () => {};
  }, []);

  useEffect(() => {
    const amount = round(
      round(round(item.case_quantity) * round(item.case_price)) +
        round(round(item.quantity) * round(item.price))
    );

    setItem((prevState) => {
      return {
        ...prevState,
        amount,
      };
    });

    return () => {};
  }, [item.case_quantity, item.quantity, item.case_price, item.price]);

  const can_edit =
    isEmpty(state.status) || [OPEN].includes(state.status?.approval_status);

  return (
    <Content className="content-padding">
      <StockFormModal
        setField={(stock, index) => {
          setState((prevState) => {
            const items = [...prevState.items];
            items[index].stock = stock;

            if (items.length - 1 === index) {
              items.push({
                ...initialItemValues,
              });
            }

            return {
              ...prevState,
              items,
            };
          });
        }}
        ref={stockFormModal}
      />

      <EmployeeModal
        setField={({ record, column }) => {
          setState((prevState) => {
            return {
              ...prevState,
              [column]: record,
            };
          });
        }}
        ref={employeeModal}
      />
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />
      <AccountFormModal
        setField={(account) => {
          setState((prevState) => ({
            ...prevState,
            account,
          }));
        }}
        ref={accountFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={
              hasAccess({
                auth,
                access: ACCESS_ADD,
                location,
              })
                ? () => {
                    setState({
                      ...initialValues,
                      date: moment(),
                      branch: auth.user?.branches?.[0] || null,
                      items: [
                        {
                          ...initialItemValues,
                        },
                      ],
                    });
                    setItem(initialItemValues);
                    setRecords([]);
                  }
                : null
            }
          />
        </div>
      </div>

      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Project"
                          value={search_state.project?.name}
                          onFocus={() => {
                            onProjectSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onProjectSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const project = options.projects?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              project,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.projects}
                          column="name"
                          error={errors.project}
                          // onAddItem={() => accountFormModal.current.open()}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Account"
                          value={search_state.account?.name}
                          onFocus={() => {
                            onSupplierSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onSupplierSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const account = options.accounts?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              account,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.accounts}
                          column="name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors?.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[OPEN, STATUS_CLOSED, CANCELLED] || []}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="RR #"
                          name="rr_no"
                          formItemLayout={smallFormItemLayout}
                          value={search_state[transaction_counter.key]}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <TextFieldGroup
                          label="Reference"
                          name="reference"
                          formItemLayout={smallFormItemLayout}
                          value={search_state.reference}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={
                                <i className="fa-solid fa-magnifying-glass pad-right-8"></i>
                              }
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  page_size,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: { ...search_state },
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      <div
        style={{
          background: "#fff",
          padding: 24,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <Row>
          <Col span={12}>
            <span className="module-title">{title}</span>
          </Col>
          {/* <Col span={12} className="has-text-right">
            <Button
              type="link"
              onClick={() => {
                navigate("/cashier");
              }}
            >
              Go Back Cashiering
            </Button>
          </Col> */}
        </Row>

        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: {
                  ...state,
                  items: state.items.filter((o) => !isEmpty(o.stock?._id)),
                  total_estimated_labor_cost,
                  total_estimated_mobilization_cost,
                  total_estimated_material_cost,
                  contingency,
                  total_project_margin: taxes.total_project_margin,
                  total_project_cost: taxes.total_project_cost,
                  total_actual_material_cost,
                  total_actual_labor_cost,
                  total_actual_mobilization_cost,
                  actual_contingency,
                  total_actual_project_margin:
                    taxes.total_actual_project_margin,
                  total_actual_project_cost: taxes.total_actual_project_cost,
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
              });

              axios.post(`/api/projects/${state.project?._id}`, {
                ...state.project,
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    label={transaction_counter.label}
                    value={state[transaction_counter.key]}
                    error={errors.remarks}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}
            <DatePickerFieldGroup
              label="Date"
              name="date"
              value={state.date || null}
              onChange={(value) => {
                onChange({
                  key: "date",
                  value: value,
                  setState,
                });
              }}
              error={errors.date}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Project"
                  value={state.project?.name}
                  onFocus={() => {
                    onProjectSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onProjectSearch({ value, setOptions })}
                  onChange={(index) => {
                    const project = options.projects?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      project,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.projects}
                  column="name"
                  error={errors.project}
                  // onAddItem={() => accountFormModal.current.open()}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  disabled
                  label="Account"
                  name="account"
                  value={state.project?.account?.name}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <TextFieldGroup
                  disabled
                  label="Project Type"
                  name="project_type"
                  value={state.project?.project_type}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={6}>
                <CheckboxFieldGroup
                  label="Taxable"
                  name="is_taxable"
                  error={errors.is_taxable}
                  checked={state.project?.is_taxable}
                  formItemLayout={threeColumnFormItemLayout}
                  onChange={(e) => {
                    const is_taxable = e.target.checked;

                    setState((prevState) => ({
                      ...prevState,
                      project: {
                        ...prevState.project,
                        is_taxable,
                      },
                    }));
                  }}
                />
              </Col>
              <Col span={6}>
                <CheckboxFieldGroup
                  label="Vat Ex"
                  name="is_vat_exclusive"
                  error={errors.is_vat_exclusive}
                  checked={state.project?.is_vat_exclusive}
                  formItemLayout={threeColumnFormItemLayout}
                  onChange={(e) => {
                    const is_vat_exclusive = e.target.checked;

                    setState((prevState) => ({
                      ...prevState,
                      project: {
                        ...prevState.project,
                        is_vat_exclusive,
                      },
                    }));
                  }}
                />
              </Col>
            </Row>

            <SelectFieldGroup
              label="Sales Division"
              value={state.sales_division?.name}
              onSearch={(value) =>
                onEmployeeSearch({ value, options, setOptions })
              }
              onFocus={() =>
                onEmployeeSearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const employee = options.employees?.[index] || null;

                setState((prevState) => {
                  return {
                    ...prevState,
                    sales_division: employee,
                  };
                });
              }}
              error={errors.stock?.name}
              formItemLayout={formItemLayout}
              data={options.employees}
              column="display_name"
              onAddItem={() => employeeModal.current.open("sales_division")}
            />

            <SelectFieldGroup
              label="Account Manager"
              value={state.account_manager?.name}
              onSearch={(value) =>
                onEmployeeSearch({ value, options, setOptions })
              }
              onFocus={() =>
                onEmployeeSearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const employee = options.employees?.[index] || null;

                setState((prevState) => {
                  return {
                    ...prevState,
                    account_manager: employee,
                  };
                });
              }}
              error={errors.stock?.name}
              formItemLayout={formItemLayout}
              data={options.employees}
              column="display_name"
              onAddItem={() => employeeModal.current.open("account_manager")}
            />

            <SelectFieldGroup
              label="Artist in Charge"
              value={state.artist_in_charge?.name}
              onSearch={(value) =>
                onEmployeeSearch({ value, options, setOptions })
              }
              onFocus={() =>
                onEmployeeSearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const employee = options.employees?.[index] || null;

                setState((prevState) => {
                  return {
                    ...prevState,
                    artist_in_charge: employee,
                  };
                });
              }}
              error={errors.stock?.name}
              formItemLayout={formItemLayout}
              data={options.employees}
              column="display_name"
              onAddItem={() => employeeModal.current.open("artist_in_charge")}
            />

            <DatePickerFieldGroup
              label="Deadline"
              name="deadline"
              value={state.deadline || null}
              onChange={(value) => {
                onChange({
                  key: "deadline",
                  value: value,
                  setState,
                });
              }}
              error={errors.deadline}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col span={8}>
                <TextFieldGroup
                  label="Rough Size Width"
                  name="rough_size_width"
                  value={state.rough_size_width}
                  error={errors.rough_size_width}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                  formItemLayout={threeColumnFormItemLayout}
                />
              </Col>
              <Col span={8}>
                <TextFieldGroup
                  label="Height"
                  name="rough_size_height"
                  value={state.rough_size_height}
                  error={errors.rough_size_height}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                  formItemLayout={formItemLayout}
                />
              </Col>
              <Col span={8}>
                <TextFieldGroup
                  label="Area"
                  name="total_area"
                  value={state.total_area}
                  error={errors.total_area}
                  formItemLayout={formItemLayout}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />
            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={12}>
                <span className="module-title">MATERIAL COST ESTIMATE</span>
              </Col>
            </Row>

            <Table
              dataSource={addKeysToArray([
                ...state.items,
                {
                  footer: 1,
                  quantity: sumBy(state.items, (o) => round(o.quantity)),
                  case_quantity: sumBy(state.items, (o) =>
                    round(o.case_quantity)
                  ),
                  amount: total_estimated_material_cost,
                  actual_amount: total_actual_material_cost,
                },
              ])}
              columns={items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={12}>
                <span className="module-title">ESTIMATED LABOR COST</span>
              </Col>
            </Row>
            <div className="report-container">
              <table>
                <thead>
                  <tr>
                    <th>Expenses</th>
                    <th className="has-text-right" width={300}>
                      Estimate Cost
                    </th>
                    <th className="has-text-right" width={300}>
                      Actual Cost
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {labor_costs.map((labor_cost) => {
                    return (
                      <tr>
                        <td>{labor_cost.name}</td>
                        <td className="has-text-right">
                          {[undefined, OPEN].includes(
                            state.status?.approval_status
                          ) ? (
                            <input
                              value={state[labor_cost.estimate_key]}
                              name={labor_cost.estimate_key}
                              className="input-value has-text-right"
                              type="number"
                              // step={0.01}
                              onChange={(e) => {
                                const target = e.target;
                                onChange({
                                  key: e.target.name,
                                  value: e.target.value,
                                  setState,
                                });
                              }}
                            />
                          ) : (
                            state[labor_cost.estimate_key]
                          )}
                        </td>
                        <td className="has-text-right">
                          {[undefined, OPEN].includes(
                            state.status?.approval_status
                          ) ? (
                            <input
                              value={state[labor_cost.actual_key]}
                              name={labor_cost.actual_key}
                              className="input-value has-text-right"
                              type="number"
                              // step={0.01}
                              onChange={(e) => {
                                const target = e.target;
                                onChange({
                                  key: e.target.name,
                                  value: e.target.value,
                                  setState,
                                });
                              }}
                            />
                          ) : (
                            state[labor_cost.actual_key]
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th className="has-text-right">
                      {numberFormat(total_estimated_labor_cost)}
                    </th>
                    <th className="has-text-right">
                      {numberFormat(total_actual_labor_cost)}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={12}>
                <span className="module-title">
                  ESTIMATED MOBILIZATION COST
                </span>
              </Col>
            </Row>
            <div className="report-container">
              <table>
                <thead>
                  <tr>
                    <th className="has-text-left">Expenses</th>
                    <th className="has-text-right" width={300}>
                      Estimate Cost
                    </th>
                    <th className="has-text-right" width={300}>
                      Actual Cost
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {mobilization_costs.map((mobilization_cost) => {
                    return (
                      <tr>
                        <td>{mobilization_cost.name}</td>
                        <td className="has-text-right">
                          {[undefined, OPEN].includes(
                            state.status?.approval_status
                          ) ? (
                            <input
                              value={state[mobilization_cost.estimate_key]}
                              name={mobilization_cost.estimate_key}
                              className="input-value has-text-right"
                              type="number"
                              // step={0.01}
                              onChange={(e) => {
                                const target = e.target;
                                onChange({
                                  key: e.target.name,
                                  value: e.target.value,
                                  setState,
                                });
                              }}
                            />
                          ) : (
                            state[mobilization_cost.estimate_key]
                          )}
                        </td>
                        <td className="has-text-right">
                          {[undefined, OPEN].includes(
                            state.status?.approval_status
                          ) ? (
                            <input
                              value={state[mobilization_cost.actual_key]}
                              name={mobilization_cost.actual_key}
                              className="input-value has-text-right"
                              type="number"
                              // step={0.01}
                              onChange={(e) => {
                                const target = e.target;
                                onChange({
                                  key: e.target.name,
                                  value: e.target.value,
                                  setState,
                                });
                              }}
                            />
                          ) : (
                            state[mobilization_cost.actual_key]
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th className="has-text-right">
                      {numberFormat(total_estimated_mobilization_cost)}
                    </th>
                    <th className="has-text-right">
                      {numberFormat(total_actual_mobilization_cost)}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={8}>
                <span className="module-title">CONTINGENCY RATE</span>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <TextFieldGroup
                  label="RATE PERCENTAGE"
                  name="contingency_rate"
                  type="number"
                  value={state.contingency_rate}
                  error={errors.contingency_rate}
                  formItemLayout={smallFormItemLayout}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row style={{ borderTop: "1px solid #000" }}>
              <Col span={24} className="has-text-right has-text-weight-bold">
                Estimated Contingency:&emsp;{numberFormat(contingency)}
                &emsp;&emsp;&emsp; Actual Contingency:&emsp;
                {numberFormat(actual_contingency)}
              </Col>
            </Row>

            <Row style={{ margin: "20px 0 20px 0" }}>
              <Col span={8}>
                <span className="module-title">Taxes</span>
              </Col>
            </Row>

            <div className="report-container">
              <table>
                <thead>
                  <tr>
                    <th className="has-text-left">Taxes</th>
                    <th className="has-text-right" width={300}>
                      Estimate Cost
                    </th>
                    <th className="has-text-right" width={300}>
                      Actual Cost
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {taxes_costs.map((taxes_cost) => {
                    return (
                      <tr>
                        <td>{taxes_cost.name}</td>
                        <td className="has-text-right">
                          {numberFormat(taxes[taxes_cost.estimate_key])}
                        </td>
                        <td className="has-text-right">
                          {numberFormat(taxes[taxes_cost.actual_key])}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <th className="has-text-right has-text-weight-bold">
                      TOTAL PROJECT MARGIN
                    </th>
                    <th className="has-text-right has-text-weight-bold">
                      {numberFormat(taxes.total_project_margin)}%
                    </th>
                    <th className="has-text-right has-text-weight-bold">
                      {numberFormat(taxes.total_actual_project_margin)}%
                    </th>
                  </tr>
                  <tr>
                    <th className="has-text-right has-text-weight-bold">
                      TOTAL PROJECT COST
                    </th>
                    <th className="has-text-right has-text-weight-bold">
                      {numberFormat(taxes.total_project_cost)}
                    </th>
                    <th className="has-text-right has-text-weight-bold">
                      {numberFormat(taxes.total_actual_project_cost)}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              url={url}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onDelete={() => {
                onDelete({
                  id: state._id,
                  url,
                  user: auth.user,
                  cb: () => {
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      advance_search: { ...search_state },
                    });
                  },
                });
              }}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              }}
              onClose={() => {
                onUpdateStatus({
                  url,
                  state,
                  approval_status: STATUS_CLOSED,
                  user: auth.user,
                  cb: () => {
                    edit({
                      record: state,
                      setState,
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                });
              }}
              has_print={!isEmpty(state._id)}
              has_cancel={!isEmpty(state._id)}
              onPrint={() =>
                window.open(`/print/${transaction}/${state._id}`, "_tab")
              }
              has_save={can_edit}
              additional_buttons={[
                <button
                  onClick={(e) => {
                    e.preventDefault();

                    onSubmitForm({
                      url,
                      setErrors,
                      additional_url: `generate-project-estimate/${state?._id}`,
                    });
                  }}
                  className="button is-info is-outlined control"
                >
                  Download Excel
                </button>,
                <button
                  onClick={(e) => {
                    e.preventDefault();

                    axios
                      .post(`/api/project-estimates/${state._id}/reset-po-qty`)
                      .then(() => {
                        edit({
                          record: {
                            _id: state._id,
                          },
                          setState,
                          setErrors,
                          setRecords,
                          url,
                          date_fields,
                        });
                      });
                  }}
                  className="button is-info is-outlined control"
                >
                  Reconcile PO
                </button>,
              ]}
            />
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  if (
                    hasAccess({
                      auth,
                      access: ACCESS_OPEN,
                      location,
                    })
                  ) {
                    edit({
                      record,
                      setState: (record) => {
                        setState({
                          ...record,
                          items: [
                            ...record.items,
                            {
                              ...initialItemValues,
                            },
                          ],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  }
                },
              };
            }}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page, page_size) => {
                setPageSize(page_size);
                onSearch({
                  page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              },
              total: total_records,
              pageSize: page_size,
            }}
          />
        )}
      </div>
    </Content>
  );
}
